// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_box1__AOiMz {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 95%;
  height: 250px;
  border-radius: 8px;
  border: 1px dashed black;
  background: rgba(41, 121, 255, 0.1);
  margin-top: 2rem;
}

.style_uploadVideo__wo5-N {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #4154f1;
  color: #fff;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  padding: 10px 20px;
  cursor: pointer;
}
.style_pasteVideo__--fMZ {
  background: #fff;
  color: gray;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  padding: 10px 20px;
  outline: none;
  border: none;
}

.style_pVal__A79o\\+ {
  margin-top: 1rem;
  width: 300px;
}
.style_nextBtn__SKuW- {
  font-weight: 600;
}

/* alert */
.style_step2Box__zR4DR {
  margin-top: 2rem;
  height: 60vh;
  overflow: auto;
}
.style_itemBox__vX7qr {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #2979ff;
  color: #fff;
  font-weight: 600;
  padding: 10px 20px;
  margin-block: 10px;
  border-radius: 8px;
}
.style_itemBox2__Q3RIg {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(41, 121, 255, 0.2);
  color: #2979ff;
  font-weight: 600;
  padding: 10px 20px;
  margin-block: 10px;
  border-radius: 8px;
}
.style_itemBoxAdd__q6oTb {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(41, 121, 255, 0.2);
  color: #2979ff;
  font-weight: 600;
  padding: 10px 20px;
  margin-block: 10px;
  border-radius: 8px;
}
.style_removeBtn__f2H88 {
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  background: #fff;
  border-radius: 20px;
  padding: 5px 15px;
  font-weight: 600;
}
.style_markBondary__NJn41 {
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  background: #2979ff;
  color: #fff;
  border-radius: 20px;
  padding: 5px 15px;
  font-weight: 600;
}

@media (max-width: 580px) {
  .style_markBondary__NJn41{
    font-size: 12px;
  }
}
.style_flexDiv__aPrtp {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background: rgba(41, 121, 255, 0.1);
  border-radius: 10px;
}
.style_flexDiv__aPrtp > span {
  font-weight: 700;
  font-size: 16px;
}
.style_flexDiv__aPrtp > div > span {
  font-weight: 700;
  font-size: 16px;
}

.style_titleHome__7fJN5 {
  font-size: 20px;
  font-weight: 600;
  border: none;
  outline: none;
}

.style_saveForLater__e38ZX {
  margin-right: 10px;
  background-color: rgba(41, 121, 255, 0.1);
  border-radius: 12px;
  border: none;
  padding: 10px 20px;
  font-weight: 600;
  color: black;
}

.style_cancel__rPxa- {
  background: red;
  color: #fff;
  font-weight: 600;
  border-radius: 12px;
  border: none;
  padding: 8px 20px;
}

/* step1 */

.style_uploadBtn__E-4N9 {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  background: #fff;
  margin-right: 10px;
}
.style_connectToCamera__Qug9U {
  background: #2979ff;
  border: none;
  padding: 8px 20px;
  color: #fff;
  border-radius: 8px;
}

.style_navHeader__HaRRP {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 12px;
  background: #f5f6fc;
  width: 40vw;
  height: 50px;
  padding-inline: 10px;
}

.style_activeHeader__81Ga7 {
  color: #2979ff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  background: #fff;
  width: 150px;
  height: 40px;
  cursor: pointer;
}
.style_dactiveHeader__DnwEJ {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  color: rgba(0, 0, 0, 0.5);
  width: 150px;
  height: 40px;
  cursor: pointer;
}
.style_inprogress__\\+ARZI {
  display: flex;
  align-items: center;
  padding-inline: 10px;
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  background: #fff;
  width: 100%;
  height: 60px;
  margin-top: 2rem;
}
.style_boxLast__6021\\+ {
  width: 100%;
  border-radius: 12px;
  background: rgba(41, 121, 255, 0.1);
  margin-top: 2rem;
  padding: 15px 20px;
}
.style_videoBox__Zjwao {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.style_btn1__cRKPV {
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #fff;
  height: 40px;
  border: none;
  margin-right: 10px;
}

.style_countBox__vaVF4 {
  margin-left: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 150px;
  border-radius: 12px;
  background: #fff;
  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,
    rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
  border-radius: 8px;
}
.style_numberBoxHead__IcfgK {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/pages/auth/home/style.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,aAAa;EACb,kBAAkB;EAClB,wBAAwB;EACxB,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mCAAmC;EACnC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mCAAmC;EACnC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,mCAAmC;EACnC,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;EACzC,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA,UAAU;;AAEV;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,oCAAoC;EACpC,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB;0CACwC;EACxC,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,eAAe;EACf,6BAA6B;EAC7B,4BAA4B;EAC5B,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd","sourcesContent":[".box1 {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 95%;\n  height: 250px;\n  border-radius: 8px;\n  border: 1px dashed black;\n  background: rgba(41, 121, 255, 0.1);\n  margin-top: 2rem;\n}\n\n.uploadVideo {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #4154f1;\n  color: #fff;\n  font-weight: 600;\n  border: none;\n  border-radius: 8px;\n  padding: 10px 20px;\n  cursor: pointer;\n}\n.pasteVideo {\n  background: #fff;\n  color: gray;\n  font-weight: 600;\n  border: none;\n  border-radius: 8px;\n  padding: 10px 20px;\n  outline: none;\n  border: none;\n}\n\n.pVal {\n  margin-top: 1rem;\n  width: 300px;\n}\n.nextBtn {\n  font-weight: 600;\n}\n\n/* alert */\n.step2Box {\n  margin-top: 2rem;\n  height: 60vh;\n  overflow: auto;\n}\n.itemBox {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: #2979ff;\n  color: #fff;\n  font-weight: 600;\n  padding: 10px 20px;\n  margin-block: 10px;\n  border-radius: 8px;\n}\n.itemBox2 {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: rgba(41, 121, 255, 0.2);\n  color: #2979ff;\n  font-weight: 600;\n  padding: 10px 20px;\n  margin-block: 10px;\n  border-radius: 8px;\n}\n.itemBoxAdd {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: rgba(41, 121, 255, 0.2);\n  color: #2979ff;\n  font-weight: 600;\n  padding: 10px 20px;\n  margin-block: 10px;\n  border-radius: 8px;\n}\n.removeBtn {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: none;\n  background: #fff;\n  border-radius: 20px;\n  padding: 5px 15px;\n  font-weight: 600;\n}\n.markBondary {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: none;\n  background: #2979ff;\n  color: #fff;\n  border-radius: 20px;\n  padding: 5px 15px;\n  font-weight: 600;\n}\n\n@media (max-width: 580px) {\n  .markBondary{\n    font-size: 12px;\n  }\n}\n.flexDiv {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px;\n  background: rgba(41, 121, 255, 0.1);\n  border-radius: 10px;\n}\n.flexDiv > span {\n  font-weight: 700;\n  font-size: 16px;\n}\n.flexDiv > div > span {\n  font-weight: 700;\n  font-size: 16px;\n}\n\n.titleHome {\n  font-size: 20px;\n  font-weight: 600;\n  border: none;\n  outline: none;\n}\n\n.saveForLater {\n  margin-right: 10px;\n  background-color: rgba(41, 121, 255, 0.1);\n  border-radius: 12px;\n  border: none;\n  padding: 10px 20px;\n  font-weight: 600;\n  color: black;\n}\n\n.cancel {\n  background: red;\n  color: #fff;\n  font-weight: 600;\n  border-radius: 12px;\n  border: none;\n  padding: 8px 20px;\n}\n\n/* step1 */\n\n.uploadBtn {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 10px;\n  border-radius: 12px;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  background: #fff;\n  margin-right: 10px;\n}\n.connectToCamera {\n  background: #2979ff;\n  border: none;\n  padding: 8px 20px;\n  color: #fff;\n  border-radius: 8px;\n}\n\n.navHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-radius: 12px;\n  background: #f5f6fc;\n  width: 40vw;\n  height: 50px;\n  padding-inline: 10px;\n}\n\n.activeHeader {\n  color: #2979ff;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 10px;\n  background: #fff;\n  width: 150px;\n  height: 40px;\n  cursor: pointer;\n}\n.dactiveHeader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 10px;\n  color: rgba(0, 0, 0, 0.5);\n  width: 150px;\n  height: 40px;\n  cursor: pointer;\n}\n.inprogress {\n  display: flex;\n  align-items: center;\n  padding-inline: 10px;\n  border-radius: 12px;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  background: #fff;\n  width: 100%;\n  height: 60px;\n  margin-top: 2rem;\n}\n.boxLast {\n  width: 100%;\n  border-radius: 12px;\n  background: rgba(41, 121, 255, 0.1);\n  margin-top: 2rem;\n  padding: 15px 20px;\n}\n.videoBox {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.btn1 {\n  padding: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  background: #fff;\n  height: 40px;\n  border: none;\n  margin-right: 10px;\n}\n\n.countBox {\n  margin-left: 10px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 150px;\n  border-radius: 12px;\n  background: #fff;\n  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,\n    rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;\n  border-radius: 8px;\n}\n.numberBoxHead {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-around;\n  align-content: space-between;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"box1": `style_box1__AOiMz`,
	"uploadVideo": `style_uploadVideo__wo5-N`,
	"pasteVideo": `style_pasteVideo__--fMZ`,
	"pVal": `style_pVal__A79o+`,
	"nextBtn": `style_nextBtn__SKuW-`,
	"step2Box": `style_step2Box__zR4DR`,
	"itemBox": `style_itemBox__vX7qr`,
	"itemBox2": `style_itemBox2__Q3RIg`,
	"itemBoxAdd": `style_itemBoxAdd__q6oTb`,
	"removeBtn": `style_removeBtn__f2H88`,
	"markBondary": `style_markBondary__NJn41`,
	"flexDiv": `style_flexDiv__aPrtp`,
	"titleHome": `style_titleHome__7fJN5`,
	"saveForLater": `style_saveForLater__e38ZX`,
	"cancel": `style_cancel__rPxa-`,
	"uploadBtn": `style_uploadBtn__E-4N9`,
	"connectToCamera": `style_connectToCamera__Qug9U`,
	"navHeader": `style_navHeader__HaRRP`,
	"activeHeader": `style_activeHeader__81Ga7`,
	"dactiveHeader": `style_dactiveHeader__DnwEJ`,
	"inprogress": `style_inprogress__+ARZI`,
	"boxLast": `style_boxLast__6021+`,
	"videoBox": `style_videoBox__Zjwao`,
	"btn1": `style_btn1__cRKPV`,
	"countBox": `style_countBox__vaVF4`,
	"numberBoxHead": `style_numberBoxHead__IcfgK`
};
export default ___CSS_LOADER_EXPORT___;
